<template>
  <div class="brandCard">
    <div v-if="list && list.length !== 0">
      <van-swipe-cell v-for="item in list" :key="item.id">
        <div class="cart-list">
          <div class="cart-item">
            <div class="card-name">{{ item.name }}</div>
            <div class="card-name">{{ item.bankType }}</div>
            <div class="card-num">{{ item.bankNo | encryptPhone }}</div>
          </div>
        </div>
        <template #right>
          <van-button
            square
            type="danger"
            text="删除"
            style="height: 100%"
            @click="deleteBankCard(item.id)"
          />
        </template>
      </van-swipe-cell>
    </div>

    <template v-else>
      <van-empty description="空空如也" />
    </template>
    <div class="addBtn" @click="$router.push('/pages/user/addBankCard')">
      <span>+</span> 添加银行卡
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  filters: {
    encryptPhone(phone) {
      let str2 = "";
      if (phone) {
        let str = phone.slice(0, 15);
        str2 = phone.replace(str, "***************");
      }
      return str2;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http.request(this.$http.pathMap.bankCardList, "get").then((res) => {
        this.list = res.data;
      });
    },
    deleteBankCard(id) {
      this.$dialog.confirm({ message: "确认删除吗" }).then(() => {
        this.$http
          .request(this.$http.pathMap.deleteBankCard + "/" + id, "get")
          .then((res) => {
            this.$toast('删除成功')
            this.loadData();
          });
      }).catch(err => {
        this.$toast('已取消')
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.brandCard {
  padding: 10px;
  .cart-list {
    .cart-item {
      height: 100px;
      background: #fff;
      margin-bottom: 10px;
      padding: 10px 20px;
      .card-num {
        font-size: 30px;
      }
    }
  }
  .addBtn {
    width: 100%;
    background: #fff;
    padding: 0 10px;
    line-height: 50px;
    display: flex;
    align-items: center;
    span {
      font-size: 30px;
      margin-bottom: 4px;
      margin-right: 10px;
    }
  }
}
</style>
